module.exports = __webpack_public_path__ + "img/empty-character.39bc561b.png";